import { type MaybeRefOrGetter, toValue, watch } from 'vue'

import { useScrollLock } from '@internal/helper/useScrollLock'

export const useBlockScroll = (
  shouldBlock: MaybeRefOrGetter<boolean>,
  targetElement: Parameters<typeof useScrollLock>[0] = globalThis
) => {
  const isLocked = useScrollLock(targetElement, toValue(shouldBlock))

  watch([shouldBlock], () => {
    isLocked.value = toValue(shouldBlock)
  })
}
